/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { TaskInstance } from 'ember-concurrency';
import { Platform } from 'cio/utils/push/platforms';
import TemplateModel from 'cio/models/template';
import { ApiError } from 'cio/services/api';

interface FooterArgs {
  type: string;
  recipient?: string;
  isDisabled?: boolean;
  platform?: Platform;
  preview?: Record<string, any>;
  template?: TemplateModel;
  errors?: ApiError[];
  sendTest: TaskInstance<unknown>;
  onClose?: () => unknown;
}

export default class Footer extends Component<FooterArgs> {}
